import { toggleArray } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import useBrandGroupMember from '@hooks/useBrandGroupMember'
import useBrandGroupMembers from '@hooks/useBrandGroupMembers'
import useSelector from '@hooks/useSelector'

import type { AgencyModel, BrandGroupModel } from '@models/types'

const toggleMembers = (agency: Partial<AgencyModel>, assignedMemberIds: number[], setState: Function) => {
  const updatedAssignedMembers = toggleArray(assignedMemberIds, agency.id)

  setState({
    assignedMemberIds: updatedAssignedMembers,
  })
}

const defaultState = {
  assignedMemberIds: [],
}

interface UseCreateBrandGroupMembersModalPayload {
  agencies: AgencyModel[],
  assignedMemberIds: number[],
  callbacks: {
    bulkCreateBrandGroupMembers: Function,
    toggleMembers: Function,
  },
  creating: boolean,
  filteredBrandGroupMemberIds: number[],
  hasAssignedMembers: boolean,
}

const useCreateBrandGroupMembersModal = (brandGroup: BrandGroupModel): UseCreateBrandGroupMembersModalPayload => {
  const [state, setState] = useSetState(defaultState)
  const { assignedMemberIds } = state

  const brandGroupMemberPayload = useBrandGroupMember()
  const {
    callbacks: {
      bulkCreateBrandGroupMembers,
    },
    creating,
  } = brandGroupMemberPayload

  const { filteredBrandGroupMemberIds } = useBrandGroupMembers({
    filters: {
      brand_group_id: brandGroup.id,
    },
    performHttpRequests: !!brandGroup.id,
    requestOptions: { include_member_details: true },
  })

  const agencies = useSelector(reduxState => reduxState.entities.agencies)

  const hasAssignedMembers = !!assignedMemberIds.length

  return {
    // @ts-expect-error TS2740
    agencies,
    assignedMemberIds,
    callbacks: {
      bulkCreateBrandGroupMembers,
      toggleMembers: (agency: Partial<AgencyModel>) => toggleMembers(agency, assignedMemberIds, setState),
    },
    creating,
    filteredBrandGroupMemberIds,
    hasAssignedMembers,
  }
}

export default useCreateBrandGroupMembersModal
